import requests from "./httpService";

const PolicyServices = {
 
  getPolicyById: async (id, body) => {
    return requests.get(`/onewaypickupcancellation/${id}`, body);
  },

  updatePolicy: async (id, body) => {
    return requests.put(`/onewaypickupcancellation/update/${id}`, body);
  },
};

export default PolicyServices;
